<template>
  <section class="reply-refer">
    <h2 class="bottom-border">{{title}}</h2>
    <div
      v-if="!showBuyable"
      class="abs-top-right">
      <v-button  @click="handleCancel">Back</v-button>
      <template>
        <v-button
          @click="onSave(1)"
        >Save Draft</v-button>
        <v-button
          type="primary__color"
          @click="onSave(3)"
        >Reply All To Client</v-button>
      </template>
    </div>
    <div
      v-else

      class="abs-top-right">
      <v-button @click="handleCancel">Back</v-button>
    </div>
    <div class="flex">
      <div class="main-left">
        <ul>
          <li class="flex flex-sb active">
            <span
              class="flex "
            >
              <template >
                <span class="icon icon-content">
                  <img
                    v-if="getOptionData('companySmallIcon', company_id).logo"
                    :src="getOptionData('companySmallIcon', company_id).logo? getOptionData('companySmallIcon', company_id).logo: ''"
                    alt="">
                </span>
              </template>
              <span>{{quote_name}}</span>
            </span>
          </li>
        </ul>
        <div class="box box-remark">
          <span class="title">Remarks</span>
          <div class="remarks-container">
            <div
              v-for="(item, index) in refer_remarks"
              :key="index"
              class="remark-box">
              <div class="remark-header">
                <span>{{ item.cs_name }}</span>
                <span>{{ item.created_at }}</span>
              </div>
              <p>{{ item.message }}</p>
            </div>
          </div>
          <div class="remark-add">
            <v-input
              v-model="message"
              class="mg-b-15"
              append="Add"
              @handlerAppend="handlerSendRemark"/>
          </div>
        </div>
      </div>
      <div class="main flex-1">
        <section>
          <div class="flex-sb-center pd-b-20">
            <h3 class="color-dark pd-b-0">Quote</h3>
            <v-button
              v-if="!showBuyable"
              type="danger__color"
              @click="handlerDelQuote">
              <font-awesome-icon
                icon="trash-alt"></font-awesome-icon>
              Delete Quote</v-button>
          </div>
          <el-form
            ref="form"
            :model="formData"
            :disabled="showBuyable"
            :rules="rules">
            <div>
              <div class="flex-sb">
                <div class="form-item form-half">
                  <span>Insurer Quote Status</span>
                  <el-form-item
                    ref="quote_status"
                  >
                    <v-radio-group
                      v-model="formData.quote.quote_status"
                      :border="true"
                      button
                      :rules="rules.select"
                      :list="quoteStatusOptions" />
                  </el-form-item>
                </div>
              </div>
              <div class="box">
                <div class="form-item form-half">
                  <div class="flex-sb-center mg-b-5">
                    <span>Insurer</span>
                    <span
                      class="flex-align-center pointer"
                      @click="hiddenInput('company')">
                      <font-awesome-icon
                        class="color-gray"
                        icon="eye-slash"></font-awesome-icon>
                      <span class="mg-l-14 block color-gray">Hidden from customer</span>
                    </span>
                  </div>
                  <el-form-item
                    ref="quote.company_id"
                    prop="quote.company_id"
                    :rules="rules.select"
                  >
                    <v-select
                      v-model="formData.quote.company_id"
                      :list="insureList"
                      :rules="rules.select"
                      :filterable="false"
                      :password-type="passwordType"
                      :disabled="editType == 3"
                      :show-type="showCompanyType"
                    />
                  </el-form-item>
                </div>
                <div class="form-item form-half">
                  <div class="flex-sb-center mg-b-5">
                    <span>Plan Name</span>
                    <span
                      class="flex-align-center pointer"
                      @click="hiddenInput('plan')">
                      <font-awesome-icon
                        class="color-gray"
                        icon="eye-slash"></font-awesome-icon>
                      <span class="mg-l-14 block color-gray">Hidden from customer</span>
                    </span>
                  </div>
                  <el-form-item
                    ref="quote.plan_name"
                    prop="quote.plan_name"
                    :rules="rules.select">
                    <v-input
                      v-model="formData.quote.plan_name"
                      :rules="rules.input"
                      :type="showPlanType"
                      :disabled="editType == 3 "
                    />
                  </el-form-item>
                </div>
                <div
                  class="box">
                  <h3 class="color-dark">Coverage</h3>
                  <div
                    v-for="(item,index) in coverage"
                    :key="index"
                    class="form-item form-half">
                    <span>{{item.item}}</span>
                    <el-form-item  :rules="rules.input">
                      <v-input
                        v-model="item.val"
                        prepend="$"
                        :disabled="item.is_enable==0"
                      />
                    </el-form-item>
                  </div>
                </div>
                <occuption-underwriting
                  :form="formData"
                  disabled
                  :sme-class-id="classId">
                </occuption-underwriting>

                <div
                  class="box">
                  <h3 class="color-dark">Remarks</h3>
                  <div class="form-half form-item">
                    <span>Policy Remark</span>
                    <v-input
                      v-model="formData.remarks.cs_manual_remark"
                      type="textarea"
                      :disabled="showBuyable"
                      :rows="3" />
                  </div>
                </div>
                <sme-premium-form
                  ref="premium"
                  :class-id="classId"
                  :refer-id="referId"
                  :customer-id="referData.customer_id"
                  :customer="referData.customer"
                  :order-id="orderId"
                  :form="formData"
                  :disabled="showBuyable"
                ></sme-premium-form>

                <div
                  class="box">
                  <h3 class="color-dark">Internal</h3>
                  <div class="form-half form-item">
                    <span>Internal Remarks</span>
                    <v-input
                      v-model="formData.internal.internal_remark"
                      type="textarea"
                      :disabled="showBuyable"
                      :rows="3" />
                  </div>
                  <div class="form-item form-half-6">
                    <span>Quotation File</span>
                    <el-form-item
                      ref="internal.refer_inter_quo_files"
                      prop="internal.refer_inter_quo_files"
                    >
                      <v-upload
                        :card="true"
                        :fileData="refer_inter_quo_files"
                        :otherData="{
                          type:'refer_inter_quo_files',
                          target: 'refer_inter_quo_files',
                          idKey: 'refer_inter_quo_files_path_id',
                          nameKey: 'refer_inter_quo_files_type_pic_path'
                        }"
                        @delete="handlerDeleteQuoFiles"
                        @uploadSuccess="handlerUploadSuccess"
                      />
                    </el-form-item>
                  </div>
                  <div
                    class="form-item">
                    <span>Other Files</span>
                    <file-container
                      v-for="(fileItem, fileIndex) in formData.internal.refer_inter_other_files"
                      :key="fileIndex"
                      :fileData="fileItem"
                      :edit="true"
                      :otherData="{
                        target: 'refer_inter_other_files',
                        fileIndex
                      }"
                      titleName= "Other Files"
                      @delete="handlerDeleteFile"
                      @uploadSuccess="handlerUploadSuccess" />
                    <v-upload
                      :otherData="{
                        type: 'other',
                        target: 'refer_inter_other_files'
                      }"
                      :orderUpload="true"
                      @uploadSuccess="handlerUploadSuccess" />
                  </div>
                </div>
              </div>
            </div>
          </el-form>

        </section>
      </div>
    </div>
    <!--    <div-->
    <!--      v-if="isDev"-->
    <!--      class="text-block">-->
    <!--      <v-button-->
    <!--        type="danger"-->
    <!--        @click="handlerText">Auto Fill</v-button>-->
    <!--    </div>-->

    <send-email-sms
      ref="send-email-sms"
      :form="referData"
      :type="2"
      :initContent="smsContent"
      :updateContent="true"
      @send="handlerSend"
      @skip="handlerSkip" />

  </section>
</template>
<script>
import {mapState} from 'vuex'
import MixinRules from '@/mixins/rules'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import occuptionUnderwriting from '@/views/quoting/sme/component/occuption-underwriting'
import {delSMEReferQuote, getSMEPremiumData, getSMEReferDetail, getSMEReferRemark, replySMERefer} from '@/api/sme'
import SmePremiumForm from '@/views/components/sme-premium-form'
import SendEmailSms from '@/views/components/dialogs/send-email-sms'

export default {
  name: 'ReplySMERefer',
  components: {
    // FileContainer,
    occuptionUnderwriting,
    SmePremiumForm,
    SendEmailSms
  },
  mixins: [MixinOptions, MixinRules, MixinFormat],
  props: {
    editType: {
      type: Number,
      default: 1 // 1 - reply, 2 - upgrade, 3 - renew
    },
    customerId: {
      type: [Number,String],
      default: '' // 1 - reply, 2 - upgrade
    },
    // detail 接口數據
    form: {
      type: Object,
      default: () => ({})
    },
    showBuyable: {
      type: Boolean,
      default: false
    },
    renewOrderId: {
      type: [Number, String],
      default: 0
    },
    hasEndorsNum: {
      type: Boolean,
      default: false
    },
    hasClaimNum: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      referReplyType: 0,
      isSend: 1,
      formDataLock: 0,
      quoteStatusOptions: [
        {
          name: 'Quoted',
          id: 1
        },
        {
          name: 'Rejected',
          id: 0
        },
      ],
      subForm: {
        'premium':false,
      },
      formData:{
        quote:{
          plan_name:'',
          company_id:'',
          quote_status:''
        },
        premium_other:{

        },
        remarks:{
          cs_manual_remark:''
        },
        internal:{}
      },
      refer_inter_quo_files:{},
      first: true,
      BuyableDisabled: true,
      message:'',
      refer_remarks:[],
      showPlanType:'',
      showCompanyType:false,
      passwordType:false,
    }
  },
  computed: {
    ...mapState('ticket', ['referData','ticketData', 'quoteCase', 'ticketReferForm']),
    productId() {
      return this.form.product_id
    },
    classId() {
      return this.referData.class_id
    },
    orderId() {
      return this.form.order_id
    },
    referId() {
      return this.form.refer_id
    },
    localAllOptions() {
      return this[`smeOptions${this.classId}`]||{}
    },

    title(){
      return this.editType == 3? 'Add Renew Quote' : 'Enter Quotes'
    },
    coverage(){
      let {coverage} = this.formData||{}
      return coverage||[]
    },
    list(){
      let {premium} = this.formData||{}
      return premium||[]
    },
    insureList(){
      let {insurer} = this.localAllOptions
      return insurer||[]
    },
    company_id(){
      return  this.formData.quote.company_id
    },
    quote_name(){
      let name = ''
      let {plan_name,company_id} = this.formData.quote
      this.insureList.some(item=>{
        if(item.id==company_id)
          name = item.name
      })
      return `${name||''} ${plan_name||''}`
    },
    smsContent() {
      const {
        refer_purchase_url_data,
        refer_reject_url_data,
      } = this.referData
      let {quote} = this.formData||{}
      let {quote_status} = quote||{}
      return quote_status==0?refer_reject_url_data:refer_purchase_url_data
    },
  },
  watch: {
    orderId:{
      immediate:true,
      handler(val){
        if(val){
          this.$nextTick(async ()=>{
            await this.network().getSMEPremiumData()
            this.network().getSMEReferDetail()
          })
        }
      }
    }
  },
  methods: {
    hiddenInput(type){
      if(type=='company'){
        this.passwordType = true
        this.showCompanyType = this.showCompanyType?false:true
      }else
        this.showPlanType = this.showPlanType=='password'?'':'password'
    },
    handlerDelQuote(){
      this.network().delSMEReferQuote()
    },
    handlerSkip() {
      let params ={
        ...this.replyParams,
        message:{
          is_send: 0,
          content: ''
        }

      }
      this.network().replySMERefer(params)
    },
    handlerSend(content) {
      let params ={
        ...this.replyParams,
        message:{
          is_send: 1,
          content: content
        }
      }
      this.network().replySMERefer(params)
    },
    handlerSendRemark(){
      this.network().getSMEReferRemark()
    },
    // reply_type:
    // 1:  Save Draft
    // 2: Reply All to Client
    // 3: Complete Buyable Quote(s)
    onSave(type){
      // this.$refs['premium'].validateForm()
      this.$refs['form'].validate(async (valid, rules) => {
        if(valid){
          let premium = await this.$refs['premium'].submitForm()
          let params = {
            reply_type:type,
            ...premium
          }
          this.replyParams = params
          if(type==3){
            this.$refs['send-email-sms'].changeDialog()
          }else
            this.network().replySMERefer(params)
        }else {
          this.scrollToValidDom(rules)
        }
      })

    },
    handleCancel(){
      this.first = true
      this.$emit('cancel')
    },
    // 文件上傳成功
    handlerUploadSuccess({ data, result, otherData }) {
      const { target, index, fileIndex = '', name,type } = otherData
      // const { id, path,thumb_url,url } = data
      if(target == 'refer_inter_quo_files') {
        this.$set(this.formData.internal,type,[data])
        this.refer_inter_quo_files = data
      }
      else {
        this.formData.internal[target].push(data)
      }
    },
    handlerDeleteQuoFiles({otherData}){
      let { type, index,target } = otherData
      this.$set(this.formData.internal,type,[])
      this.refer_inter_quo_files = {}
    },
    handlerDeleteFile(otherData) {
      const { fileIndex, index } = otherData
      this.formData.internal.splice(fileIndex, 1)
    },
    network(){
      return{
        getSMEPremiumData:async ()=>{
          const {data} = await getSMEPremiumData({
            order_id:this.orderId
          })
          this.formData = {...this.formData,...data}
          let {internal={}} = data
          let {refer_inter_quo_files=[]} = internal||{}
          this.refer_inter_quo_files = refer_inter_quo_files.length>0?refer_inter_quo_files[0]:{}
        },
        getSMEReferRemark:async (params)=>{
          const {data} = await getSMEReferRemark({
            refer_id:this.referId,
            message:this.message
          })
          this.message = ''
          this.network().getSMEReferDetail()
        },
        getSMEReferDetail: async () => {
          const { data } = await getSMEReferDetail({
            order_id: this.orderId,
            hideLoading: true
          },this.classId)
          this.refer_remarks = data.refer_remarks
        },

        // reply_type:
        // 1:  Save Draft
        // 2: Reply All to Client
        // 3: Complete Buyable Quote(s)
        getSMEReferMain: async (params) => {
          const { data } = await getSMEReferMain({
            order_id: this.orderId,
            ...params,
            hideLoading: true
          })
          let {coverage,premium,premium_other} = this.formData
          Object.keys(data).some(key=>{
            premium.forEach(item=>{
              item.items.some(content=>{
                if(content.name==key)
                  content.val = data[key]
              })
            })
          })
          this.$set(this.formData,'premium_other',premium_other)
        },
        replySMERefer: async (params) => {
          const { data } = await replySMERefer({
            order_id: this.orderId,
            ...this.formData,
            ...params,
            hideLoading: true
          })
          const emitEvent = [
            'save-draft',
            'reply-all',
            'complete'
          ]
          this.$emit(emitEvent[params.reply_type-1])
        },
        delSMEReferQuote: async (params) => {
          const { data } = await delSMEReferQuote({
            order_id: this.orderId,
            hideLoading: true
          })
          this.$refs.form.resetFields()
          this.network().getSMEPremiumData()
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.el-button--danger__color{
  color: #D73A49;
}
.el-button--primary__color{
  background: #2EA44F;
  color: #fff;
}
.reply-refer {
  position: relative;
  // padding: 15px 15px 100px 15px;
  .abs-top-right {
    top: 5px;
    //right: 15px;
  }
  .bottom-border{
    border-bottom: 1px solid #dddfe7;
    padding-bottom: 20px;
    margin-bottom: 20px;
  }
  .icon{
    margin-right: 15px;
    img{
      height: 22px;
      width: 22px;
    }
  }
  .icon-content{
    height: 22px;
    width: 22px;
    border-radius: 5px;
    background-color: #E1E4E8;
    color: #6A737D;
    font-size: 14px;
    text-align: center;
    line-height: 22px;
  }
  .star {
    display: block;
    margin-right: 7px;
    width: 18px;
    height: 18px;
    background: #F7B500;
    clip-path: polygon(9px 0, 12px 6px, 18px 6px, 14px 12px, 16px 18px, 9px 14px, 2px 18px, 4px 12px, 0px 6px, 6px 6px);
  }
  .main-left {
    margin-right: 20px;
    min-width: 250px;
    max-width: 300px;
    ul {
      padding-bottom: 20px;
      margin-bottom: 20px;
      border-bottom: 1px solid #D1D5DA;
      li {
        display: flex;
        align-items: center;
        padding: 15px;
        // height: 50px;
        // line-height: 50px;
        color: #fff;
        font-size: 16px;
        list-style: none;
        word-break: break-word;
        cursor: pointer;
        border-radius: 6px;
        background: #0366D6;
        &.active {


        }
        .el-checkbox {
          margin-right: 10px;
        }
        .star {
          margin-right: 10px;
        }
      }
    }
  }
  .star-remark {
    display: flex;
    align-items: center;;
    margin-bottom: 15px;
    padding: 10px 15px;
    color: #91939A;
    background: #E9E9EB;
    .star {
      display: block;
      margin-right: 7px;
      width: 18px;
      height: 18px;
      background: #F7B500;
      clip-path: polygon(9px 0, 12px 6px, 18px 6px, 14px 12px, 16px 18px, 9px 14px, 2px 18px, 4px 12px, 0px 6px, 6px 6px);
    }
  }
  .flex-excess {
    display: flex;
    align-items: center;
    & > .el-checkbox {
      margin: 0 15px;
    }
    & > span {
      display: inline-block;
      padding: 0 15px;
    }
  }
  .form-excess-half {
    width: 500px;
  }
  .extra_box{
    ::v-deep .el-checkbox-group {
      .el-checkbox{
        padding: 20px  20px 0  20px;
        background: #FFFFFF;
        border: 1px solid #D1D5DA;
        box-sizing: border-box;
        border-radius: 6px;
        width: 50%;
        margin-bottom: 20px;
      }
    }
    .extra-name{
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.15px;
      color: #24292E;
      margin-bottom: 20px;
    }
    .margin-bottom{
      padding-bottom: 20px;
    }
  }
  .special-text{
    display: flex;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.15px;
    color: #d73a49;
    .flex-1{
      flex: 1;
    }
    .flex-2{
      flex: 42;
    }
    /*margin-bottom: 20px;*/
  }
}
.del_line{
  text-decoration: line-through
}
.box-remark{
  .title{
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #24292E;
  }

  .remark-add {
    z-index: 2;
    margin: 0 -15px;
    padding: 15px 15px 0 15px;
    //border-top: 1px solid #dddfe7;
  }

  .remarks-container {
    z-index: 1;
    max-height: 300px;
    overflow-y: auto;

    .remark-box {
      margin-bottom: 10px;
      font-size: 12px;
      color: #91939a;

      .remark-header {
        display: flex;
        justify-content: space-between;

        span:first-child {
          font-weight: bold;
        }
      }

      p {
        padding-bottom: 10px;
        color: #616266;
      }
    }
  }
}
</style>
